var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6D88\u606F\u901A\u77E5icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BA1\\u65B9\\u914D\\u836F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BA1\\u65B9\\u5185\\u9875-\\u5B9E\\u9645\\u6F14\\u793A\\uFF08\\u5168\\u89C6\\u56FE\\uFF09",
    transform: "translate(-1297.000000, -22.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6D88\\u606F\\u901A\\u77E5icon",
    transform: "translate(1297.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7525,11.6625 C19.1625,11.6625 19.495,11.3375 19.495,10.935 L19.495,6.1625 C19.495,4.555 18.165,3.2475 16.5275,3.2475 L3.4725,3.2475 C1.8375,3.2475 0.505,4.555 0.505,6.1625 L0.505,14.5775 C0.505,16.185 1.835,17.4925 3.4725,17.4925 L16.5275,17.4925 C18.1625,17.4925 19.495,16.185 19.495,14.5775 C19.495,14.175 19.1625,13.85 18.7525,13.85 C18.3425,13.85 18.01,14.175 18.01,14.5775 C18.01,15.38 17.345,16.035 16.5275,16.035 L3.4725,16.035 C2.655,16.035 1.99,15.3825 1.99,14.5775 L1.99,6.315 L8.435,10.25 C8.9175,10.545 9.46,10.6925 10.0025,10.6925 C10.545,10.6925 11.085,10.545 11.57,10.25 L18.015,6.315 L18.015,10.9325 C18.0125,11.335 18.345,11.6625 18.7525,11.6625 Z M10.7825,9.015 C10.3,9.31 9.7,9.31 9.215,9.015 L2.6075,4.9775 C2.86,4.8 3.1625,4.7025 3.4725,4.705 L16.5275,4.705 C16.8375,4.705 17.14,4.8 17.3925,4.9775 L10.7825,9.015 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIcon);
export default __webpack_public_path__ + "static/media/msgIcon.cd47bcbe88f7c9f9eaf12726263993b7.svg";
export { ForwardRef as ReactComponent };